import I18n from 'I18n';
import ActionButtonComponent from '../ActionButtonComponent';
import { usageTracker } from '../../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../../usage-tracker/trackerChannelIdMapping';
import { ReplyAllIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const ReplyAllButton = ({
  collapsed,
  genericChannelId,
  onClick
}) => {
  const onButtonClick = e => {
    onClick(e);
    usageTracker.track('message-reply-all', {
      action: 'message reply all',
      channel: getUsageTrackingChannel(genericChannelId)
    });
  };
  return /*#__PURE__*/_jsx(ActionButtonComponent, {
    onClick: onButtonClick,
    collapsed: collapsed,
    buttonIcon: ReplyAllIcon,
    "data-test-id": 'reply-all-button',
    i18nButtonText: I18n.text('conversations-inbox-message-history.email.replyAll')
  });
};
ReplyAllButton.displayName = 'ReplyAllButton';
export default ReplyAllButton;